import React from 'react';
import { useSelector } from "react-redux";
import { Spin, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import CardCard from "../../components/CardCard/CardCard";
import usePracticeSession from "../../hooks/usePracticeSession";
import useTranslation from '../../hooks/useTranslation';

const CardRunPage = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    // Методику выбирает страница выбора практики и кладёт в redux вместе с
    // practiceId: жёсткая константа здесь открывала бы сессию не той политикой,
    // которой практика была создана.
    const { practiceId, learningMethod } = useSelector((state) => state.practice);

    // Сессия ведётся локально: вопросы приходят окном, ответы уходят пачкой.
    const { item, isLoading, finished, error, answer } = usePracticeSession({
        practiceId,
        learningMethod,
    });

    if (error) {
        return (
            <div style={{ textAlign: 'center', marginTop: '50px' }}>
                <p>{error}</p>
                <Button type="primary" onClick={() => navigate('/learn')}>{t('practice.run.back')}</Button>
            </div>
        );
    }

    // Конец практики приходит признаком в ответе, а не текстом ошибки: раньше здесь
    // сравнивалась формулировка «No active questions were found.», и правка этого
    // сообщения на бэкенде молча заменила бы поздравление на ошибку.
    if (finished) {
        return (
            <div style={{ textAlign: 'center', marginTop: '50px' }}>
                <p>{t('practice.run.finished')}</p>
                <Button type="primary" onClick={() => navigate('/learn')}>{t('practice.run.back')}</Button>
            </div>
        );
    }

    return (
        <div style={{ position: 'relative' }}>
            {item ? (
                <CardCard
                    card={item}
                    handleCorrectClick={() => answer(true)}
                    handleIncorrectClick={() => answer(false)}
                />
            ) : (
                <div style={{ textAlign: 'center', marginTop: '50px' }}>
                    <p>{t('practice.run.noItem')}</p>
                </div>
            )}

            {isLoading && (
                <div style={{
                    position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    background: 'rgba(255, 255, 255, 0.7)', zIndex: 1000,
                }}>
                    <Spin tip={t('practice.run.loading')} size="large" />
                </div>
            )}
        </div>
    );
};

export default CardRunPage;
